/**
 * Declaring object for the default blue color
 */
const rapidBackground = {
	paper : '#FFFFFF' ,
	default : '#f0f3f9' ,
};

export default rapidBackground;
